import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Axios from 'axios';
import Cookies from 'universal-cookie';
import Logo from '../../images/homesite-logo.svg';


const cookies = new Cookies();

const useStyles = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function Login(props) {
    const [logged, setLogged] = useState(true)
    const [username, setUserName] = useState(null)
    const [password, setPassword] = useState(null)
    const [loginIncorrect, setLoginIncorrect] = useState(null)

    const classes = useStyles();

    const handleUsername = (e) => {
        setUserName(e.target.value)
    }
    const handlePassword = (e) => {
        setPassword(e.target.value)
    }

    const LogIn = (e) => {
        e.preventDefault()
        Axios.post(props.base_url + 'endpoint/login', { username: username, password: password, operation: 'sign_in' })
            .then(res => {
                if (res.data === 'Incorrect Login') {
                    setLoginIncorrect(true)
                }
                else {
                    cookies.set('dataUser', res.data.dataUser, { path: '/' })
                    cookies.set('user_name', res.data.user_name, { path: '/' })
                    cookies.set('email', res.data.email, { path: '/' })
                    cookies.set('user_id', res.data.user_id, { path: '/' })
                    window.location.href = "/"
                }
            })

    }

    loginIncorrect && cookies.remove('dataUser')

    const IsLogged = () => {
        if (cookies.get('dataUser')) {
            window.location.href = "/"
        }
        else {
            setLogged(false)
        }
    }

    useEffect(() => {
        IsLogged()
    }, [])

    return (
        <>
            {!logged &&
                <Container component="main" maxWidth="xs" style={{ display: 'flex', height: '100vh', alignItems: 'center' }}>
                    <CssBaseline />
                    <div className={classes.paper}>

                        <img src={Logo} style={{ width: '150px' }} alt="logo" />

                        <Typography style={{ textAlign: 'center' }} component="h2" variant="h6">
                            Panel de Control de Administración de Propiedades
                        </Typography>


                        <form className={classes.form} noValidate onSubmit={LogIn}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Usuario"
                                name="username"
                                autoFocus
                                onChange={handleUsername}
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Contraseña"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                onChange={handlePassword}
                            />
                            {loginIncorrect && <p className="mt-3 mb-0" style={{ color: 'red' }}>Nombre de usuario o contraseña invalidos</p>}
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                            >
                                Ingresar
                                </Button>

                        </form>

                        <a href="/forgotten">Recuperar contraseña</a>
                    </div>

                </Container>
            }
        </>
    );
}